import React, {Component} from 'react'
import locale from '../locale'
import { Table } from 'components/UI'
import getTradeRecord from 'controllers/school/getTradeRecord'
import TransactionSummaryModal from 'template/Modals/TransactionSummary'
import RemarksModal from 'template/Modals/Remarks'
import moment from 'moment'
import Picker from 'react-month-picker';
import TransactionSearchFloat from 'template/Floats/TransactionSearchFloat';
import __R, { userCan } from 'containers/__R'

const MONTHS = [__('Jan', locale), __('Feb', locale), __('Mar', locale), __('Apr', locale), __('May', locale), __('Jun', locale),
 __('Jul', locale), __('Aug', locale), __('Sep', locale), __('Oct', locale), __('Nov', locale), __('Dec', locale)];

class tuitionRecordTable extends Component{
  constructor(props){
    super(props)

    this.state = {
      tuitionList: [],
      fetching: false,
      selectedYear: '',
      selectedMonth: '',
      openFloatModal: false,
      floatTarget: '',
    }

    this.onDateClicked = this.onDateClicked.bind(this)
    this.onDateChanged = this.onDateChanged.bind(this)
    this.openFloat = this.openFloat.bind(this)
    this.closeFloat = this.closeFloat.bind(this)
    this.onSubmitSearch = this.onSubmitSearch.bind(this)
    this.fetchTradeRecord = this.fetchTradeRecord.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onItemsCountPerPageChange = this.onItemsCountPerPageChange.bind(this)
  }

  componentWillMount(){
    this.fetchTradeRecord(1, 10)
  }

  fetchTradeRecord(newPageNumber, newAmountPerPage){
    const schoolId = localStorage.getItem('schoolId')
    const {studentId} = this.props
    const {selectedYear, selectedMonth} = this.state

    this.setState({fetching: true})

    getTradeRecord(schoolId, {student_id_list: [studentId], paging_or_not: 1, amount_per_page: newAmountPerPage, page_number: newPageNumber} )
    .then((res) => {
      this.setState({
        tuitionList: res.result_list,
        fetching: false,
        pagination: {
          itemsCountPerPage: res.amount_per_page,
          activePage: res.current_page_number,
          totalItemsCount: res.total_record_amount,
        }
      })
    })
  }

  onDateClicked(){
    this.refs.pickAMonth.show();
  }

  onDateChanged(year, month){
    const schoolId = localStorage.getItem('schoolId')
    const {studentId} = this.props
    let newMonth;
    let searchDate;
    if(month < 10){
      newMonth = `0${month}`
    }else {
      newMonth = month
    }

    searchDate = `${year}-${newMonth}-01`

    this.setState({selectedYear: year, selectedMonth: newMonth, fetching: true});

    getTradeRecord(schoolId, {
      student_id_list: [studentId],
      start_date: moment(searchDate).format('YYYY-MM-DD'),
      end_date: moment(searchDate).endOf('month').format("YYYY-MM-DD")
    })
    .then((res) => {
      this.setState({
        tuitionList: res.result_list,
        fetching: false,
        pagination: {
          itemsCountPerPage: res.amount_per_page,
          activePage: res.current_page_number,
          totalItemsCount: res.total_record_amount,
        }
      })
    })
    this.refs.pickAMonth.dismiss();
  }

  openFloat(e){
    this.setState({floatTarget: e.currentTarget, openFloatModal: true}, () => {
      this.forceUpdate()
    })
  }

  closeFloat(){
    this.setState({openFloatModal: false})
  }

  onSubmitSearch(data){
    const schoolId = localStorage.getItem('schoolId')
    const {studentId} = this.props
    const {selectedYear, selectedMonth} = this.state

    let startDate = `${selectedYear}-${selectedMonth}-1`

    this.setState({fetching: true});

    if(!data){
      return getTradeRecord(schoolId, {student_id_list: [studentId], start_date: startDate, end_date: moment().format('YYYY-MM-DD')})
      .then((res) => {
        this.setState({
          tuitionList: res.result_list,
          fetching: false,
          pagination: {
            itemsCountPerPage: res.amount_per_page,
            activePage: res.current_page_number,
            totalItemsCount: res.total_record_amount,
          }
        })
      })
    }

    getTradeRecord(schoolId, {student_id_list: [studentId], transaction_number: data})
    .then((res) => {
      this.setState({
        tuitionList: res.result_list,
        fetching: false,
        pagination: {
          itemsCountPerPage: res.amount_per_page,
          activePage: res.current_page_number,
          totalItemsCount: res.total_record_amount,
        }
      })
    })
  }

  onPageChange(activePage){
		if (activePage == this.state.pagination.activePage) {
      return;
    }

    this.fetchTradeRecord(activePage, this.state.pagination.itemsCountPerPage)
	}

	onItemsCountPerPageChange(itemsCountPerPage){

    this.fetchTradeRecord(1, itemsCountPerPage)
	}

  render(){
    let {tuitionList = [], fetching, selectedYear, selectedMonth, openFloatModal, floatTarget, pagination} = this.state
    if(!pagination){
      return(
        <div />
      )
    }
    const source = [
      __('Cash', locale),
      __('Credit Card', locale),
      __('Cheque', locale),
      __('Transfer', locale),
      __('School Credit', locale),
      __('ClassTopBase Credit', locale),
      __('WeChat Barcode', locale),
      __('Alipay Barcode', locale),
      __('WeChat Web Pay', locale),
      __('Alipay Web Pay', locale),
      __('WeChat Transfer', locale),
      __('Alipay Transfer', locale),
      __('Poster Online Payment', locale),
    ]
    const type = ['', __('Charged', locale), __('Refunded', locale)]
    const feeType = ['', __('lessons', locale), __('Hour', locale)]

    let fields = [{
      name: 'name',
      title: '',
      getTdProps: ({trData}) => {
        return {
          style: {width: "50%", padding: '15px'}
        }
      },
      getTdContent: ({ trData: studentInfo })=>{
        return (
          <div>
            <div className='transactionDate'>{moment(studentInfo.transaction_date).format(__('MMM DD, YYYY', locale))}</div>
            <div className='tuitionClass'>{studentInfo.class_name ? studentInfo.class_name : __('Top Up', locale)}</div>
            <div className='transactionNumber'>{studentInfo.transaction_number}</div>
          </div>
        )
      }
    }, {
      name: 'age',
      title: '',
      getTdProps: ({trData}) => {
        return {
          style: {width: "25%", padding: '15px'}
        }
      },
      getTdContent: ({ trData: studentInfo }) => {
        let amount;
        let discountAmount = '';
        if(studentInfo.class_fee_type === 0){
          amount = moment(studentInfo.trEndDate).format(__('MMM DD, YYYY', locale))
        } else if (studentInfo.class_fee_type === 1){
          amount = parseInt(studentInfo.trQuantity)
        } else if (studentInfo.class_fee_type === 2){
          amount = studentInfo.trQuantity
        } else {
          amount = '-'
        }

        let feeUnit;
        if(typeof(studentInfo.class_fee_type) != 'undefined' ){
          feeUnit = feeType[studentInfo.class_fee_type]
        }

        if(studentInfo.discount_amount > 0){
          discountAmount = __('Discounted', locale) + ' ' + studentInfo.discount_amount
        } else {
          discountAmount = ''
        }

        return (
          <div>
            <div className='transactionDate'>{source[studentInfo.source_or_direction]}</div>
            <div className='tuitionClass'>
              {discountAmount + ' ' + type[studentInfo.trType] + ' ' + studentInfo.trTransactionAmount}
            </div>
            {studentInfo.class_fee_type !== null && <div className='transactionNumber'>{amount + ' ' + feeUnit}</div>}
          </div>
        )
      }
    }]

    const settings = [
      {
        title: __('Receipt', locale),
        onClick: ({trData: studentInfo})=>{
          TransactionSummaryModal({
            id: studentInfo.id,
            student: studentInfo.student_name,
            transaction_number: studentInfo.transaction_number,
            operator_name: studentInfo.operator_name,
            student_email: studentInfo.student_email
          })
        },
        isDisabled: (opts) => {
          return !userCan('send_trade_record_email')
        }
      },
      {
        title: __('Remark', locale),
        onClick: ({trData: studentInfo}) => {
          console.log('open remark')
          RemarksModal({id: studentInfo.id, type: 'finance'})
        },
        hasAlert: ({ trData: studentInfo })=>{
          return studentInfo.trRemark && studentInfo.trRemark.length > 0;
        },
        isDisabled: (opts) => {
          return !userCan('edit_trade_record_note')
        }
      },
    ]

    return(
      <div className='studentTuitionRecord' ref={(r) => {this.studentTuitionRecordRef = r}}>
        <Table
          data={tuitionList}
          fields={fields}
          className='tuitionRecordTable'
          settingThTitle={' '}
          settingWidth={'25%'}
          settings={settings}
          useMultiSelection={false}
          oneSettingPerRow={false}
          fetching={fetching}
          hideDropdownCaret={true}
          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
          pagination={pagination}
          usePagination={true}
          onPageChange={this.onPageChange}
          onItemsCountPerPageChange={this.onItemsCountPerPageChange}
          hasTopUtilSection={true}
          topUtilSection = {
            <div className='tutionFilter'>
              <span className='tuitionYear'>
                { (selectedYear == '' && selectedMonth == '') ? __('All Record', locale) : moment(selectedYear+'-'+selectedMonth, 'YYYY-MM').format(__('MMMM YYYY', locale))}
              </span>
              <span className='pull-right tuitionReceipt' onClick={this.openFloat}><i className='fa icon-barcode'></i>{__('Search Receipt', locale)}</span>
              <span className='pull-right tuitionCalendar' onClick={this.onDateClicked}><i className='fa icon-calendar'></i>{__('Month Filter', locale)}</span>
              <span className='pull-right tuitionReceipt' onClick={() => {
                this.setState({selectedYear: '', selectedMonth: ''})
                this.fetchTradeRecord(1, 10)
              }}><i className='fa icon-folder'></i>{__('All Record', locale)}</span>
              <Picker
                ref="pickAMonth"
                years={{min: {year:2014, month:1}, max: {year: moment().year(), month:moment().month() + 1}}}
                value={{year: selectedYear, month: selectedMonth}}
                lang={MONTHS}
                theme="dark"
                onChange={this.onDateChanged}>
              </Picker>
            </div>
          }
        />
        <TransactionSearchFloat
          onSubmitSearch={this.onSubmitSearch}
          show={openFloatModal}
          target={floatTarget}
          onCloseFloat={this.closeFloat}
          container={this.studentTuitionRecordRef}
        />
      </div>
    )
  }
}


export default tuitionRecordTable



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Tables/tuitionRecordTable.js